import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { BuilderExtension } from "../BuilderExtension";
/**
 * Оборачивает объект со значением в массив, для последующего применения группировки
 */
export var ValueGroupExtension = /*#__PURE__*/function (_BuilderExtension) {
  _inherits(ValueGroupExtension, _BuilderExtension);
  var _super = _createSuper(ValueGroupExtension);
  function ValueGroupExtension() {
    _classCallCheck(this, ValueGroupExtension);
    return _super.apply(this, arguments);
  }
  _createClass(ValueGroupExtension, [{
    key: "serialize",
    value: function serialize(cls) {
      var value = this.next.serialize(cls);
      return typeof value !== 'undefined' ? [value] : undefined;
    }
  }, {
    key: "create",
    value: function create() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [undefined];
      var params = arguments.length > 1 ? arguments[1] : undefined;
      if (!Array.isArray(data) || data.length > 1) throw new Error("Bad Data, expected an array of exactly one element, found ".concat(JSON.stringify(data)));
      return this.next.create(data[0], params);
    }
  }, {
    key: "createProjection",
    value: function createProjection() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [undefined];
      var params = arguments.length > 1 ? arguments[1] : undefined;
      return this.next.createProjection(data[0], params);
    }
  }]);
  return ValueGroupExtension;
}(BuilderExtension);